module.exports = __webpack_public_path__ + "static/img/banner-title-old2.86e277e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner-title-old2.png
// module id = 6NOg
// module chunks = 1